/**
 * 기업명 확인 '검토 항목만 보기' — 목록·상세가 공유하는 토글 하나.
 *
 * 본문 하이라이트 클릭으로 상세에 들어가면, 클릭한 표기가 확인 필요가 아니어도 보이도록
 * 상세에서만 임시로 끈다. 상세를 떠나면(뒤로·빈 곳 클릭·탭 이동) 들어오기 전 값으로 되돌려
 * 목록 필터가 사용자 모르게 꺼져 있지 않게 한다. 사용자가 직접 토글을 바꾸면 그 값이 이긴다.
 */
export type CompanyNameReviewToggleState = {
  needsConfirmationOnly: boolean;
  /** 본문 클릭 진입 전 값. null = 임시 OFF 중이 아님 */
  restoreValue: boolean | null;
};

export type CompanyNameReviewToggleAction =
  | { type: "set"; value: boolean }
  | { type: "enter-from-document" }
  | { type: "leave-detail" };

export const INITIAL_COMPANY_NAME_REVIEW_TOGGLE: CompanyNameReviewToggleState =
  { needsConfirmationOnly: false, restoreValue: null };

export const companyNameReviewToggleReducer = (
  state: CompanyNameReviewToggleState,
  action: CompanyNameReviewToggleAction,
): CompanyNameReviewToggleState => {
  switch (action.type) {
    case "set":
      return { needsConfirmationOnly: action.value, restoreValue: null };
    case "enter-from-document":
      return {
        needsConfirmationOnly: false,
        // 상세에서 다른 표기를 또 클릭해도 처음 값을 지킨다
        restoreValue: state.restoreValue ?? state.needsConfirmationOnly,
      };
    case "leave-detail":
      return state.restoreValue === null
        ? state
        : { needsConfirmationOnly: state.restoreValue, restoreValue: null };
  }
};
